import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';
import MenuBar from '../components/Menubar';

type Props = {
  isOpen: boolean;
  handleModalClose(): void;
  user: any;
  yoloId: number;
  handleTagSave(): void;
  items: any;
  selectedItemCategory: any;
  selectedItemId: any;
  selectedTags: any;
  tags: any
  onTagClick(id):void
};

const customStyles = {
  content: {
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    border: 0,
    background: '#f9c5b4'
  },
};

const AddMoreTagsModal: React.FC<Props> = (props) => {

  const closeModel = ()=>{
    console.log("close clicked")
    props.handleModalClose();
  }

  const hideTags = () => {
    closeModel();
  }

  const onTagClick = (id) => {
    props.onTagClick(id);
  };

  const handleTagSave = () => {
    props.handleTagSave();
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={closeModel}
      overlayClassName="customModalOverlay"
      style={customStyles}
    >
      <div className="container">
        <MenuBar user={props.user}/>
        <div className="small-container add-yolo-info text-center notification-settings">
          <div className="yolo-container text-center">
            <h2 className="futuralt-book mt-4 pt-2">Add Tags</h2>
            <h2 className="futuralt-book pt-2 mb-2">CHECK ANY THAT APPLY</h2>
          </div>
          <div className="yoTagGrid">
            {props.tags.map((tag) => (
              <label key={tag.id} className="yo-tag">
                <input
                  type="checkbox"
                  onChange={() => onTagClick(tag.id)}
                  checked={props.selectedTags.includes(tag.id)}
                />
                <span>{tag.name}</span>
              </label>
            ))}
          </div>
          <div className="mt-4 mb-4 d-flex black justify-content-space-between align-items-center uppercase">
            <h1>
              <button className="next-button" onClick={hideTags}>BACK</button>
            </h1>
            <h1>
              <button className="next-button" onClick={handleTagSave}>SAVE</button>
            </h1>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AddMoreTagsModal;